import { createContext, useContext, useState } from 'react';

const BlueprintContext = createContext(null);

export function BlueprintProvider({ children }) {
  const [blueprintMode, setBlueprintMode] = useState(false);
  const toggle = () => setBlueprintMode(prev => !prev);
  return (
    <BlueprintContext.Provider value={{ blueprintMode, toggle }}>
      <div className={blueprintMode ? 'blueprint-active' : ''}>
        {children}
      </div>
    </BlueprintContext.Provider>
  );
}

export const useBlueprint = () => useContext(BlueprintContext);
